module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"openguide":"Facilitator guide (new tab)"},"fi":{"openguide":"Pelinjohtajan ohjeet (uusi tab)"},"sv":{"openguide":"Instruktioner för spelledare (ny flik)"},"de":{"openguide":"Anweisungen für den Moderator (neuen Tab)"},"ko":{"openguide":"퍼실리테이터 가이드(새 탭에서 열기)"}}')
  delete Component.options._Ctor
}
